export default "__VITE_ASSET__13f3db46__"